/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Nav_Reply_Incomplete_HintInputs */



/**
* | output |
* | --- |
* | "Review the reply and mark as complete if done." |
*
* @param {Error_Nav_Reply_Incomplete_HintInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const error_nav_reply_incomplete_hint = /** @type {((inputs?: Error_Nav_Reply_Incomplete_HintInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Nav_Reply_Incomplete_HintInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Revoyez la reponse et marquez-la comme terminee si fait.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Prüfen Sie die Antwort und markieren Sie sie als erledigt, falls Sie damit fertig sind.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Rivedi la risposta e, se completata, contrassegnala come completa.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Просмотрите ответ и отметьте его как выполненный, если он завершен.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Revise la respuesta y marque como completa si está completa.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("请检查回复内容，如果已完成，请标记为已完成。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("返信を確認し、完了した場合は完了としてマークします。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("उत्तर की समीक्षा करें और पूरा होने पर उसे पूर्ण के रूप में चिह्नित करें।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Analise a resposta e marque-a como concluída se estiver tudo certo.")
	return /** @type {LocalizedString} */ ("Review the reply and mark as complete if done.")
});